import {
  formatDateObjectToBrowserDate,
  formatDateObjectToBrowserTime
} from 'utilities/date';

export function formatDateTime(dateTime) {

  if (!dateTime) {
    return { date: '', time: '' };
  }

  const date = new Date(dateTime);

  const formatted = {
    date: formatDateObjectToBrowserDate(date),
    time: formatDateObjectToBrowserTime(date)
  };

  return formatted;

}